export default "__VITE_ASSET__Df8b$W97__"